<template>
  <div class="forum">
    <v-container class="d-flex flex-column">
      <h1 class="mb-5 warning align-self-start black--text rounded px-2 py-0">Djinni bot (Mimiron)</h1>

      <v-row>
        <v-col>
          <div class="text-h6">
            Price range USD
          </div>
          <div class="d-flex">
            <v-text-field 
              outlined
              label="From" 
              type="number" 
              hide-details
              v-model.number="input.range.from"
              class="mr-3"
            ></v-text-field>

            <v-text-field 
              outlined
              label="To" 
              type="number" 
              hide-details
              v-model.number="input.range.to"
            ></v-text-field>
          </div>
        </v-col>

        <v-col>
          <v-textarea 
            outlined 
            label="Text" 
            v-model="input.text"
            hide-details
          ></v-textarea>
        </v-col>

        <v-col class="d-flex flex-column">
          <div class="d-flex flex-grow-1 flex-column">
            <v-text-field 
              outlined
              label="Search query" 
              v-model="input.search"
              hide-details
              class="mb-2"
            ></v-text-field>
            <v-text-field 
              outlined
              label="Max. messages" 
              type="number"
              v-model.number="input.max_messages"
              hide-details
              class="mb-2"
            ></v-text-field>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
              <v-checkbox class="ma-0" v-model="input.passive_search" hide-details label="Passive"></v-checkbox>
              <v-spacer></v-spacer>
              <v-btn 
                color="warning" 
                :loading="loading" 
                @click="start"
                class="align-self-end"
              >Start</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-card color="warning" class="d-flex align-self-start align-center pa-4" v-if="last_session">
        <h4 class="mr-4 black--text">Bot Status</h4>
        <v-chip small color="black" class="mr-2">Total scanned: {{ last_session.data.total_scanned }}</v-chip>
        <v-chip small color="black" class="mr-2">Total sent: {{ last_session.data.sent_messages }}</v-chip>
      </v-card>

      <h2 class="mt-5 mb-2">Execution Logs</h2>
      <v-data-table
        :headers="headers"
        :items="data"
        class="elevation-1"
        :loading="loading"
        :items-per-page="-1"
      >
        <template v-slot:item.createdAt="{ item }">
          {{ $formatDate(item.createdAt) }}
        </template>
        <template v-slot:item.search="{ item }">
          {{ item.input.search }}
        </template>
        <template v-slot:item.text="{ item }">
          <v-card flat max-width="300" rounded class="black ma-2 pa-2">
            <pre>{{ item.input.text }}</pre>
          </v-card>
        </template>
        <template v-slot:item.range="{ item }">
          <v-card flat width="150" rounded class="black ma-2 pa-2">
            <pre>{{ addUsd(item.input.range.from) || '🤫' }} - {{ addUsd(item.input.range.to) || '🤫' }}</pre>
          </v-card>
        </template>
        <template v-slot:item.sent_messages="{ item }">
          {{ item.data.sent_messages }}
        </template>
        <template v-slot:item.max="{ item }">
          {{ item.input.max_messages }}
        </template>
        <template v-slot:item.total_scanned="{ item }">
          {{ item.data.total_scanned }}
        </template>
        <template v-slot:item.rejected="{ item }">
          <span :class="{ 'green--text': !item.data.rejects }">
            {{ item.data.rejects }}
          </span>
        </template>
        
      </v-data-table>
    </v-container>

  </div>
</template>

<script>
import { DjinniAPI } from '@/api';
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      headers: [
        { text: 'Date', value: 'createdAt' },
        { text: 'Search query', value: 'search' },
        { text: 'Text', value: 'text' },
        { text: 'Range', value: 'range' },
        { text: 'Sent messages', value: 'sent_messages' },
        { text: 'Max', value: 'max' },
        { text: 'Total scanned', value: 'total_scanned' },
        { text: 'Rejected', value: 'rejected' },
      ],
      input: {
        range: {
          from: 2000,
          to: 2500,
        },
        text: 'Привет, ищем сильного React Native на британский MedTech стартап\n\nзп от 2500', 
        search: 'react native', 
        max_messages: 1, 
        passive_search: true,
      },
      pass: '',
      last_session: false,
    }
  },
  components: {

  },
  methods: {

    addUsd(val) {
      if(val) {
        return val + '$'
      }
    },

    sync() {
      this.loading = true;
      return this.$store.dispatch('djinni/updateData')
        .then(() => this.ping())
        .finally(() => {
          this.loading = false;
        })
    },

    ping() {
      return new Promise(async (resolve, reject) => {
        
        const call = async () => {
          this.last_session = await DjinniAPI.getLastSession()
            .then(res => res.data);

          if(this.last_session.data.error) {
            reject(this.last_session.data.error)
          }

          if(this.last_session.currently_busy) {
            setTimeout(() => {
              call();
            }, 1000)
          } else {
            this.last_session = false;
            resolve();
          }
        }

        call();
      })
    },

    start() {
      this.loading = true;
      return DjinniAPI.unchainBeast(this.input)
        .then(() => this.ping())
        .then(() => this.sync())
        .finally(() => {
          this.loading = false;
        })
    },
  },

  created() {
    this.sync();
  },

  computed: {
    ...mapGetters({
      data: 'djinni/data',
    }),
  },
}
</script>

<style lang="scss" scoped>

.devs {
  
}

</style>